import axios from 'axios'

const state = {
    list: [],
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
}

const options = {
    headers: {
        'Accept': 'application/vnd.api+json',
        'Content-Type': 'application/vnd.api+json',
    }
};

const actions = {

    getDeviceGroupDetails(context, payload) {
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/device_groups/' + payload.id)
            .then((response) => {
                return response
            })
    },

    addDeviceGroup(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/device_groups', { idSite: payload.idSite, name: payload.name }, options)
            .then((response) => {
                return response
            })
    },

    addDeviceGroupInsect(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/device_groups/' + payload.deviceGroupId + '/insect', { idInsect: payload.idInsect }, options)
            .then((response) => {
                return response
            })
    },

    updateDeviceGroup(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/device_groups/' + payload.deviceGroupId, { name: payload.name }, options)
            .then((response) => {
                return response
            })
    },

    deleteDeviceGroupInsect(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/device_groups/' + payload.deviceGroupId + '/insect', { idInsect: payload.idInsect }, options)
            .then((response) => {
                return response
            })
    },

    deleteDeviceGroup(context, payload) {
        return axios.delete(process.env.VUE_APP_API_BASE_URL+'/device_groups/' + payload.id)
            .then((response) => {
                return response
            })
    },

    addRule(context, payload) {
        return axios.post(process.env.VUE_APP_API_BASE_URL+'/device_groups/' + payload.deviceGroupId + '/rule', {}, options)
            .then((response) => {
                return response
            })
    },

    updateRule(context, payload) {
        return axios.put(process.env.VUE_APP_API_BASE_URL+'/device_groups/' + payload.deviceGroupId + '/rule', {
            min: payload.min,
            max: payload.max
        }, options).then((response) => {
            return response
        })
    }

}

const getters = {
    list: state => state.list,
};

const deviceGroups = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default deviceGroups;
